/**
 * api-middleware.js
 * Created by calhosh on 4/21/2020.
 */

import axios from 'axios';

//#region Actions
export const GET_ONLINE_STATE = 'api/onlineState/get';
export const API_ERRORS = 'api/errors';
//#endregion

/*
 * Redux Middleware for handling API calls
 * On successful api response, the response and responseObj are attached to the action and passed to next middleware
 * On Error and error object is attached to the action and API_ERROR action is dispatched
 * Injection of config into the middleware to use it for authentication
 * config can be passed as a parameter to the middleware in applyMiddleware method when creating the store
 *
 */
const apiMiddleware = (config) => (store) => (next) => (action) => {
	const __NAME = 'API Middleware';

	// skip to next middleware for API_ERROR action
	if (action.type === API_ERRORS) {
		next(action);
		return Promise.reject(action.error);
	}
	// Check if the app is online
	// If application is not online skip authentication and go to next middleware
	// returning promise.resolve so that action.dispatch can be chained with then()

	// Commented until we manage online state
	if (!action.isOnline && !(action.meta && action.meta.docHelper)) {
		next(action);
		return Promise.resolve(`[${__NAME}] - action.type:`, action.type, 'Skipping Authentication as app is offline');
	}

	/* Existence of the meta.api object is the trigger to treat this
	 * action as an API call. */
	if (!(action.meta && action.meta.api)) {
		next(action);
		return Promise.resolve(`[${__NAME}] - action.type:`, action.type, 'Skipping API call since API meta not available');
	}

	const {method, url, data, headers} = action.meta.api,
		auth = action.meta.auth;

	// Check for auth error and skip api call incase of auth error;
	if (!(action.meta && action.meta.docHelper)) {
		if (config && config.useAuth === false && (!auth || !auth.token)) {
			action.response = {};
			action.responseObj = {};
			next(action);
			return Promise.resolve(action);
		}

		if (auth && auth.error && !auth.token) {
			action.response = {};
			action.responseObj = {};
			next(action);
			return Promise.resolve(action);
		}
	}

	return new Promise((resolve, reject) => {
		if (!config) {
			const configMsg = `
			Config unavailable.
			The AD package requires config to get the authorization token for the api call.`;
			console.log(`[${__NAME}] - action.type:`, action.type, configMsg);
		}

		/*
		 * If config is not passed as parameter to the middleware
		 * the below function checkLoggedIn from AD package will skip authentication
		 */

		const needsJSON = ['post', 'put', 'patch'].includes(method.toLowerCase());
		const customHeaders = headers || {};
		if (!(action.meta && action.meta.docHelper)) {
			if (auth && auth.token) {
				customHeaders.Authorization = 'Bearer ' + auth.token;
			}
		}
		customHeaders['Content-Type'] = needsJSON ? 'application/json' : '';
		const headers = customHeaders;

		axios({method, url, data, headers})
			.then((response) => {
				action.response = response.data;
				action.responseObj = response;
				next(action);
				return resolve(action);
			})
			.catch((error) => {
				var apponlinestate = store.getState().apponlinestate;
				// console.log(
				// 	`[${__NAME}] - action.type:`,
				// 	action.type,
				// 	' In order to verify if its a legit discconect, we call [GET_ONLINE_STATE] when api call recieves an error'
				// );
				store.dispatch({type: GET_ONLINE_STATE});

				action.error = error;
				action.response = {};
				action.responseObj = {};
				//next(action);
				next({type: API_ERRORS, error});
				return reject(error);
			});
	});
};

export default apiMiddleware;
